// Needs to be CommonJS as we use it in the build process as well…
export const slugify = (text: string, separator: string = "-"): string => {
  if (!text || typeof text !== "string") return text;
  return text
    .toString()
    .normalize("NFD") // decompose unicode characters
    .replace(/[\u0300-\u036f]/g, "") // remove diacritics
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "") // remove non-word [a-z0-9_], non-whitespace, non-hyphen characters
    .replace(/[\s_-]+/g, separator) // swap any length of whitespace, underscore, hyphen characters with a separator
    .replace(/^-+|-+$/g, ""); // remove leading, trailing -
};
